import { NgModule } from '@angular/core';
import { RulebasedConfiguratorEventListener } from './rulebased-configurator-event.listener';

@NgModule({})
export class RulebasedConfiguratorEventModule {
  constructor(_configuratorEventListener: RulebasedConfiguratorEventListener) {}
}
